// Chromium refuses to claim USB interfaces in these classes (WebUSB "protected
// interface class" restriction) — some composite printers bundle one of these
// (e.g. a HID sub-interface for a customer display) alongside the real, claimable
// bulk-transfer interface, so interface 0 isn't always safe to assume.
const PROTECTED_INTERFACE_CLASSES = new Set([
  0x01, // Audio
  0x03, // HID
  0x08, // Mass Storage
  0x0b, // Smart Card
  0x0e, // Video
  0x10, // Audio/Video
  0xe0, // Wireless Controller
]);

// Liste toutes les interfaces candidates (classe non protégée, avec un endpoint
// OUT), quel que soit leur numéro d'interface. Il peut y en avoir plusieurs :
// seule celle liée au pilote WinUSB sur l'OS sera réellement "claimable", donc
// l'appelant doit essayer chaque candidate jusqu'à ce que claimInterface réussisse.
const listCandidateInterfaces = (device) => {
  const candidates = [];
  for (const iface of device.configuration.interfaces) {
    for (const alt of iface.alternates) {
      if (PROTECTED_INTERFACE_CLASSES.has(alt.interfaceClass)) continue;
      const outEndpoint = alt.endpoints.find((e) => e.direction === "out");
      if (outEndpoint) {
        candidates.push({ interfaceNumber: iface.interfaceNumber, outEndpoint });
        break;
      }
    }
  }
  return candidates;
};

// Essaie de claim chaque interface candidate jusqu'à ce qu'une réussisse
// (seule l'interface liée au pilote WinUSB côté OS peut réellement être claim).
export const findPrinterInterface = async (device) => {
  const candidates = listCandidateInterfaces(device);
  for (const candidate of candidates) {
    try {
      await device.claimInterface(candidate.interfaceNumber);
      return candidate;
    } catch (err) {
      console.warn(
        `Interface ${candidate.interfaceNumber} non claimable, essai suivant :`,
        err.message
      );
    }
  }
  return null;
};
